import { AccountObjectStoreFacade } from "../account-object/account-object.store-facade";
import { SyncUpItem } from "./sync-up-item.model";
import { Observable } from "rxjs/Observable";
import { Qry } from "../query-facade";
import * as actions from "./sync-up-item.actions";
import { ChangeQItem } from "../../../core/services/sync-up/item";
import { OperationResult } from "../../../core/services/sync-up/operation-result";
import { createSelector } from 'reselect';

export class SyncUpItemStoreFacade extends AccountObjectStoreFacade<SyncUpItem> {

    getAll(): Observable<Array<SyncUpItem>> {

        const selector = createSelector(
            (state: any) => state.syncUpItem.ids,
            (state: any) => state.syncUpItem.entities,
            (state: any) => state.account.selected,
            (ids, entities, accountId) => {
            return ids.map(id => entities[id])
                .filter((item: SyncUpItem) => item.account === accountId || item.account === undefined);
            }
        );

        return this.select(selector);
    }

    create(syncUpItem: SyncUpItem): void {
        this.dispatch(new actions.CreateAction(syncUpItem, {persistable: true, restful: false}));
    }

    createFromChangeQItem(changeQItem: ChangeQItem): void {
        this.create(new SyncUpItem({
            id: changeQItem.key,
            account: changeQItem.account,
            changeQItem
        }));
    }

    update(syncUpItem: SyncUpItem): void {
        this.dispatch(new actions.UpdateAction(syncUpItem, {persistable: true, restful: false}));
    }

    updateFromOperationResult(result: OperationResult): void {
        this.dispatch(new actions.UpdateFromOperationResultAction(result));
    }

    insert(syncUpItem: SyncUpItem): void {
        this.dispatch(new actions.CreateAction(syncUpItem, {persistable: true, restful: false}));
    }

    remove(syncUpItem: SyncUpItem): void {

        if (!syncUpItem) {
            return;
        }

        this.dispatch(new actions.RemoveAction(syncUpItem, {persistable: true, restful: false}));
    }

    removeByKey(key: string): void {
        this.dispatch(new actions.RemoveByKeyAction({key}));
    }

    retry(syncUpItem: SyncUpItem): void {
        this.dispatch(new actions.RetryAction(syncUpItem));
    }

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/sync-up-item/sync-up-item.store-facade.ts